import LazyLoad from 'vanilla-lazyload';

export default (data, selectedSection, selectedCategoryID, labels) => ({
  data: data,
  entries: data.entries,
  entriesFiltered: [],
  selectedSection: selectedSection,
  selectedCategoryID: selectedCategoryID,
  sectionCategories: [],
  error: false,
  limit: 3,
  increment: 3,
  hasMore: true,
  labels: labels,
  get displayedPosts() {
    return this.entriesFiltered.slice(0, this.limit);
  },
  lazyLoadInstance: null,
  init() {
    const url = new URL(window.location.href);
    const categoryParam = url.searchParams.get('category');

    if (categoryParam) {
      this.selectedCategoryID = categoryParam;
    }
    this.loadData();
    this.updateUrlParams();
    this.hasMore = this.entriesFiltered.length > this.limit;

    this.lazyLoadInstance = new LazyLoad({
      elements_selector: '.grid-inspiration .lazy-bg-placeholder '
    });

    this.$watch('selectedCategoryID', (newValue, oldValue) => {
      this.loadData();
    });

    this.$watch('entriesFiltered', (newValue, oldValue) => {
      if (newValue !== oldValue) {
        this.hasMore = newValue.length > this.limit;
      }
    });
  },
  updateUrlParams() {
    const url = new URL(window.location.href);

    if (this.selectedCategoryID === null || typeof this.selectedCategoryID === 'undefined') {
      url.searchParams.delete('category');
    } else {
      url.searchParams.set('category', String(this.selectedCategoryID));
    }

    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  },
  loadMore() {
    this.limit += this.increment;
    this.hasMore = this.entriesFiltered.length > this.limit;

    this.$nextTick(() => {
      this.lazyLoadInstance.update();
    });
  },
  loadData() {
    const validSections = ['clientCasesCategories', 'inspirationLibraryCategories', 'productStoriesCategories'];

    if (!validSections.includes(this.selectedSection)) {
      console.error('Unknown section selected:', this.selectedSection);
      return;
    }

    this.sectionCategories = this.data.sections.find((section) => section.handle === this.selectedSection);

    if (this.selectedCategoryID == null) {
      this.selectedCategoryID = this.sectionCategories.categories[0].id;
    }

    this.entriesFiltered = this.entries[this.selectedSection][this.selectedCategoryID].rows;
    this.updateUrlParams();

    this.$nextTick(() => {
      this.lazyLoadInstance.update();
    });
  }
});
